import { RouterRootState } from "connected-react-router";
import React, { FC, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import MobileAccountCard from "../../../components/account/MobileAccountCard";
import { MobileAccountDetails } from "../../../components/account/MobileAccountDetails";
import MqttServiceAccountCard from "../../../components/account/MqttServiceAccountCard";
import { MqttServiceAccountCertificates } from "../../../components/account/MqttServiceAccountCertificates";
import STidMobileAccountCard from "../../../components/account/STidMobileAccountCard";
import { StIdMobileAccountDetails } from "../../../components/account/STidMobileAccountDetails";
import VingcardAccountCard from "../../../components/account/VingcardAccountCard";
import { VingcardAccountDetails } from "../../../components/account/VingcardAccountDetails";
import { useDialog } from "../../../components/dialog/DialogContext";
import ItemContentTabTwo from "../../../components/item-content-two/item-content-tab_two";
import { Topic } from "../../../components/item-content-two/Topic";
import SimpleItemDetails from "../../../components/item-content/SimpleItemDetails";
import { toast } from "react-toastify";
import { ACCOUNT_TYPE_SYSNAME, HID_MOBILE_ACCESS_CONSTANTS, LDAP_CONSTANTS, MQTT_SERVICE_CONSTANTS, STID_MOBILE_CONSTANTS, VINGCARD_CONSTANTS, AUTH_CONSTANTS, AUTH_TYPE } from "../../../constants/account-constants";
import commands from "../../../constants/commands";
import { LICENSE_HID_MOBILE_ACCESS, LICENSE_SSO_ENTRA, LICENSE_STID_MOBILE, LICENSE_VINGCARD } from "../../../constants/license-constants";
import { AccountSubCmds } from "../../../constants/sub-commands";
import { useLocale } from "../../../contexts/localeContext";
import { TopicContextProvider } from "../../../contexts/topic/TopicContextProvider";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import { BreadcrumbLink } from "../../../models/BreadcrumbLink";
import { ContentWrapper } from "../../../models/ContentWrapper";
import { ExecuteCommand } from "../../../models/ExecuteCommand";
import { MultiSelectOption } from "../../../models/MultiSelectOption";
import { TabSummary } from "../../../models/TabSummary";
import { useGlobalState } from "../../../Providers";
import LDAPAccountCard from "../../../components/account/LDAPAccountCard";
import { LDAPAccountDetails } from "../../../components/account/LDAPAccountDetails";
import { executeCommand } from "../../../services/executeCommandService";
import { editAccount, getMobileAccountById, getMobileAccountConfigurations, getMobileAccountNamesWithPagination, storeMobileAccount } from "../../../services/mobileAccountService";
import { getErrorMessage, showLoadItemError } from "../../../services/utilities/ServiceError";
import { SPECIFIC_HELP_KEY } from "../../../constants/specific-help-constant";
import {AuthAccountDetails} from "../../../components/account/AuthAccountDetails.tsx";
import AuthAccountCard from "../../../components/account/AuthAccountCard.tsx";
import {AuthAccountAdvanced} from "@/components/account/AuthAccountAdvanced.tsx";

const getIdFromPath = (path: string) => {
    const splitPath = path.split('/');
    return splitPath[splitPath.length - 1];
}

const allItemsPath = '/access-control/configuration/accounts';
const itemPath = '/access-control/configuration/account/';

const MobileAccount: FC = () => {
    const { translate } = useLocale();
    const initialTabs = [
        { id: 1, label: translate.byKey(TranslationKeys.details), badge: 0, showInitial: true, isActive: true },
        { id: 2, label: translate.byKey(TranslationKeys.identityProviderGroups), badge: 0, showInitial: true, isActive: false },
    ];
    const history = useHistory();
    const pageId = useSelector((state: RouterRootState) => getIdFromPath(state.router.location.pathname));
    const [itemId, setItemId] = useState(pageId);
    const [isAuthTenetRequired, setIsAuthTenetRequired] = useState(false);
    const initialItem = {
        details: {
            organizationId: { id: '', value: '', origValue: '', accountValueId: 0 },
            userId: { id: '', value: '', origValue: '', accountValueId: 0 },
            password: { id: '', value: '', origValue: '', accountValueId: 0 },
            partNumber: { id: '', value: '', origValue: '', accountValueId: 0 },
            credentialsAvailable: { id: '', value: '', origValue: '', accountValueId: 0 },
            siteId: { id: '', value: '', origValue: '', accountValueId: 0 },
            readerConfigId: { id: '', value: '', origValue: '', accountValueId: 0 },
            // LDAP specific fields
            connectionName: { id: '', value: '', origValue: '', accountValueId: 0 },
            host: { id: '', value: '', origValue: '', accountValueId: 0 },
            base: { id: '', value: '', origValue: '', accountValueId: 0 },
            port: { id: '', value: '', origValue: '', accountValueId: 0 },
            username: { id: '', value: '', origValue: '', accountValueId: 0 },
            // sslEnabled: { id: '', value: false, origValue: false, accountValueId: 0 }, // Not supported yet
            // tlsEnabled: { id: '', value: false, origValue: false, accountValueId: 0 }, // Not supported yet
            // anonymousConnection: { id: '', value: false, origValue: false, accountValueId: 0 }, // Not supported yet
            tlsBrokerCert: { id: '', value: '', origValue: '', accountValueId: 0 },
            tlsPrimoCert: { id: '', value: '', origValue: '', accountValueId: 0 },
            tlsBrokerLocation: { id: '', value: '', origValue: '', accountValueId: 0 },
            url: { id: '', value: '', origValue: '', accountValueId: 0 },
            debugLevel: { id: '', value: '', origValue: '', accountValueId: 0 },
            pollingInterval: { id: '', value: '', origValue: '', accountValueId: 0 },
            lastSynced: { id: '', value: '', origValue: '', accountValueId: 0 },
            vingCardCert: { id: '', value: '', origValue: '', accountValueId: 0 },
            // Auth
            issuer: { id: '', value: '', origValue: '', accountValueId: 0},
            tenantId: { id: '', value: '', origValue: '', accountValueId: 0},
            clientId: { id: '', value: '', origValue: '', accountValueId: 0},
            redirectUri: { id: '', value: '', origValue: '', accountValueId: 0},
            cookieName: { id: '', value: '', origValue: '', accountValueId: 0},
            clientType: { id: '', value: '', origValue: '', accountValueId: 0}
        },
        id: undefined,
        accountTypeId: undefined,
        enabled: false,
        accountTypeSysname: undefined,
        isPasswordCaptured: false,
        tempPassword: undefined
    }
    const [currentItem, setCurrentItem] = useState<any>(initialItem);
    const [breadcrumb, setBreadcrumb] = useState<BreadcrumbLink[]>([]);
    const [busy, setBusy] = useState(false);
    const [tabs, setTabs] = useState<TabSummary[]>(initialTabs);
    const [isAccountPopulated, setIsAccountPopulated] = useState(true);
    const dialog = useDialog();
    const [selectedItem, setSelectedItem] = useState<MultiSelectOption | undefined>(undefined);
    const { buildInfo, setSpecificHelpTopicKey, loadBuildInfo } = useGlobalState() ?? {};

    useEffect(() => {
        setItemId(pageId);
    }, [pageId])

    useEffect(() => {
        reloadPage();
    }, [itemId, buildInfo?.licenceIds])

    const isAccountLicensed = (accountTypeSysname: string): boolean => {

        if (ACCOUNT_TYPE_SYSNAME.ID_STID_MOBILE_ID === accountTypeSysname) {
            return buildInfo?.licenceIds?.includes(LICENSE_STID_MOBILE) ?? false;
        }
        else if (ACCOUNT_TYPE_SYSNAME.ID_HID_MOBILE_ACCESS === accountTypeSysname) {
            return buildInfo?.licenceIds?.includes(LICENSE_HID_MOBILE_ACCESS) ?? false;
        }
        else if (ACCOUNT_TYPE_SYSNAME.ID_VINGCARD === accountTypeSysname) {
           return buildInfo?.licenceIds?.includes(LICENSE_VINGCARD) ?? false;
        }
        else if (ACCOUNT_TYPE_SYSNAME.ID_MQTT_SERVICE === accountTypeSysname) {
            return true; // MQTT Broker is always available
        }
        else if (ACCOUNT_TYPE_SYSNAME.ID_AUTH === accountTypeSysname) {
            return buildInfo?.licenceIds?.includes(LICENSE_SSO_ENTRA) ?? false;
        }

        return false;
    }

    const reloadPage = async () => {
        try {
            let account;

            if (itemId) {
                setCurrentItem(initialItem);  //Clear form state
                setIsAccountPopulated(false);
                account = await getMobileAccountById(itemId);

                //Set specific help topic key based on account type
                setSpecificHelpTopicKey && setSpecificHelpTopicKey(getHelpTopicKey(account.accountTypeSysname));

                //Might have to add logic to do a check before adding account Configs
                const accountConfiguration = (await getMobileAccountConfigurations(account.id, account.accountTypeId)).rows.filter(config => !config.name.includes('password')); // TODO: backend should not send passwords here
                const newAccountDetails = accountConfiguration.reduce((returnValue, listItem) => {
                    switch (listItem.name) {
                        // Organization Id
                        case HID_MOBILE_ACCESS_CONSTANTS.ORG_ID:
                            return { ...returnValue, organizationId: { id: listItem.accountAttributeId, value: listItem.accountValue ?? '', origValue: '', accountValueId: listItem.id } };
                        // User Id
                        case HID_MOBILE_ACCESS_CONSTANTS.USER_ID:
                        case STID_MOBILE_CONSTANTS.USER_ID:
                            return { ...returnValue, userId: { id: listItem.accountAttributeId, value: listItem.accountValue ?? '', origValue: '', accountValueId: listItem.id } };
                        // Password
                        case HID_MOBILE_ACCESS_CONSTANTS.PASSWORD:
                        case STID_MOBILE_CONSTANTS.PASSWORD:
                        case VINGCARD_CONSTANTS.PASSWORD:
                        case LDAP_CONSTANTS.PASSWORD:
                            const decodedPwd = listItem.accountValue? atob(listItem.accountValue) : '';
                            const decodedOrigPwd = listItem.origValue ? atob(listItem.origValue) : '';
                            return { ...returnValue, password: { id: listItem.accountAttributeId, value: decodedPwd ?? '', origValue: decodedOrigPwd, accountValueId: listItem.id } };
                        // Part number
                        case HID_MOBILE_ACCESS_CONSTANTS.PART_NUMBER:
                            return { ...returnValue, partNumber: { id: listItem.accountAttributeId, value: listItem.accountValue ?? '', origValue: '', accountValueId: listItem.id } };
                        // Site Id
                        case STID_MOBILE_CONSTANTS.SITE_ID:
                            return { ...returnValue, siteId: { id: listItem.accountAttributeId, value: listItem.accountValue ?? '', origValue: '', accountValueId: listItem.id } };
                        // Reader Config Id
                        case STID_MOBILE_CONSTANTS.CONFIGURATION_ID:
                            return { ...returnValue, readerConfigId: { id: listItem.accountAttributeId, value: listItem.accountValue ?? '', origValue: '', accountValueId: listItem.id } };
                        // Credentials Available
                        case HID_MOBILE_ACCESS_CONSTANTS.CREDENTIALS_AVAILABLE:
                            return { ...returnValue, credentialsAvailable: { id: listItem.accountAttributeId, value: listItem.accountValue ?? '', origValue: '', accountValueId: listItem.id } };
                        // Credits Available
                        case STID_MOBILE_CONSTANTS.CREDITS_AVAILABLE:
                            const credentials = listItem.accountValue ? translate.byKeyFormatted(TranslationKeys.stidCreditsAvailable, { credits: listItem.accountValue, credentials: parseInt(listItem.accountValue) / 5 }) : '';
                            return { ...returnValue, credentialsAvailable: { id: listItem.accountAttributeId, value: credentials, origValue: '', accountValueId: listItem.id } };
                        // LDAP - Connection Name
                        case LDAP_CONSTANTS.CONNECTION_NAME:
                            return { ...returnValue, connectionName: { id: listItem.accountAttributeId, value: listItem.accountValue ?? '', origValue: '', accountValueId: listItem.id } };
                        // LDAP - Host
                        case LDAP_CONSTANTS.HOST:
                            return { ...returnValue, host: { id: listItem.accountAttributeId, value: listItem.accountValue ?? '', origValue: '', accountValueId: listItem.id } };
                        // LDAP - Base
                        case LDAP_CONSTANTS.BASE:
                            return { ...returnValue, base: { id: listItem.accountAttributeId, value: listItem.accountValue ?? '', origValue: '', accountValueId: listItem.id } };
                        // LDAP - Port
                        case LDAP_CONSTANTS.PORT:
                            return { ...returnValue, port: { id: listItem.accountAttributeId, value: listItem.accountValue ?? '', origValue: '', accountValueId: listItem.id } };
                        // LDAP - Username
                        case LDAP_CONSTANTS.USERNAME:
                            return { ...returnValue, username: { id: listItem.accountAttributeId, value: listItem.accountValue ?? '', origValue: '', accountValueId: listItem.id } };
                        // LDAP - Anonymous Connection
                        case LDAP_CONSTANTS.ANONYMOUS_CONNECTION:
                            return { ...returnValue, anonymousConnection: { id: listItem.accountAttributeId, value: listItem.accountValue ?? '', origValue: '', accountValueId: listItem.id } };
                        // MQTT service settings
                        case MQTT_SERVICE_CONSTANTS.TLS_URL:
                            return { ...returnValue, tlsUrl: { id: listItem.accountAttributeId, value: listItem.accountValue ?? '', origValue: '', accountValueId: listItem.id } };
                        case MQTT_SERVICE_CONSTANTS.TLS_PORT:
                            return { ...returnValue, tlsPort: { id: listItem.accountAttributeId, value: listItem.accountValue ?? '', origValue: '', accountValueId: listItem.id } };
                        case MQTT_SERVICE_CONSTANTS.CLIENT_ID:
                            return { ...returnValue, tlsClientId: { id: listItem.accountAttributeId, value: listItem.accountValue ?? '', origValue: '', accountValueId: listItem.id } };
                        case MQTT_SERVICE_CONSTANTS.PRIMO_CERT:
                            return { ...returnValue, tlsPrimoCert: { id: listItem.accountAttributeId, value: listItem.ksCertificateId?.toString() ?? '', origValue: '', accountValueId: listItem.id } };
                        case MQTT_SERVICE_CONSTANTS.BROKER_CERT:
                            return { ...returnValue, tlsBrokerCert: { id: listItem.accountAttributeId, value: listItem.ksCertificateId?.toString() ?? '', origValue: '', accountValueId: listItem.id } };
                        case MQTT_SERVICE_CONSTANTS.BROKER_LOCATION:
                            return { ...returnValue, tlsBrokerLocation: { id: listItem.accountAttributeId, value: listItem.accountValue ?? '', origValue: '', accountValueId: listItem.id } };
                        // Vingcard settings
                        case VINGCARD_CONSTANTS.URL:
                            return { ...returnValue, url: { id: listItem.accountAttributeId, value: listItem.accountValue ?? '', origValue: '', accountValueId: listItem.id } };
                        case VINGCARD_CONSTANTS.USERNAME:
                            return { ...returnValue, username: { id: listItem.accountAttributeId, value: listItem.accountValue ?? '', origValue: '', accountValueId: listItem.id } };
                        case VINGCARD_CONSTANTS.DEBUG_LEVEL:
                            return { ...returnValue, debugLevel: { id: listItem.accountAttributeId, value: listItem.accountValue ?? '', origValue: '', accountValueId: listItem.id } };
                        case VINGCARD_CONSTANTS.POLLING_INTERVAL:
                            return { ...returnValue, pollingInterval: { id: listItem.accountAttributeId, value: listItem.accountValue ?? '', origValue: '', accountValueId: listItem.id } };
                        case VINGCARD_CONSTANTS.LAST_SYNCED:
                            return { ...returnValue, lastSynced: { id: listItem.accountAttributeId, value: listItem.accountValue ?? '', origValue: '', accountValueId: listItem.id } };
                        case VINGCARD_CONSTANTS.VINGCARD_CERT:
                            return { ...returnValue, vingCardCert: { id: listItem.accountAttributeId, value: listItem.ksCertificateId?.toString() ?? '', origValue: '', accountValueId: listItem.id } };
                        // AUTH - Issuer
                        case AUTH_CONSTANTS.ISSUER:
                            return { ...returnValue, issuer: { id: listItem.accountAttributeId, value: listItem.accountValue ?? '', origValue: '', accountValueId: listItem.id } };
                        // AUTH - tenantId
                        case AUTH_CONSTANTS.TENANT_ID:
                            return { ...returnValue, tenantId: { id: listItem.accountAttributeId, value: listItem.accountValue ?? '', origValue: '', accountValueId: listItem.id } };
                        // AUTH - redirect URI
                        case AUTH_CONSTANTS.REDIRECT_URI:
                            return { ...returnValue, redirectUri: { id: listItem.accountAttributeId, value: listItem.accountValue ?? '', origValue: '', accountValueId: listItem.id } };
                        // AUTH - Client Id
                        case AUTH_CONSTANTS.CLIENT_ID:
                            return { ...returnValue, clientId: { id: listItem.accountAttributeId, value: listItem.accountValue ?? '', origValue: '', accountValueId: listItem.id } };
                        // AUTH - TYPE
                        case AUTH_CONSTANTS.TYPE:
                            return { ...returnValue, clientType: { id: listItem.accountAttributeId, value: listItem.accountValue ?? '', origValue: '', accountValueId: listItem.id } };
                        default:
                            return returnValue;
                    }
                }, initialItem.details);

                const newCurrentItem = {
                    details: { ...newAccountDetails },
                    id: account.id,
                    accountTypeId: account.accountTypeId,
                    enabled: account.enabled,
                    accountTypeSysname: account.accountTypeSysname,
                    tempPassword: undefined,
                    isPasswordCaptured: account.isPasswordCaptured
                }

                if (hasRequiredFields(account.accountTypeSysname, newCurrentItem)) {
                    setIsAccountPopulated(true);
                }
                if (Number(newAccountDetails.clientType?.value) !== AUTH_TYPE.GOOGLE) {
                    setIsAuthTenetRequired(true);
                }
                setSelectedItem({ label: account.name, value: account.id.toString() })
                setCurrentItem(newCurrentItem);

                const updatedTabs = updateTabBadgeTotal(0, account?.details, initialTabs);
                updatedTabs[1].isActive = newCurrentItem.accountTypeSysname === ACCOUNT_TYPE_SYSNAME.ID_AUTH;
                setTabs(updatedTabs);
            }

            setBreadcrumb([
                { value: '/access-control/configuration', displayName: translate.byKey(TranslationKeys.configuration), disableClick: true },
                { value: allItemsPath, displayName: translate.byKey(TranslationKeys.accounts) },
                { value: itemPath + `${itemId}`, displayName: `${account?.name ?? ''}` }
            ]);
        } catch (error) {
            showLoadItemError(error, dialog, translate, () => { history.push(allItemsPath) });
        }
    };

    const hasRequiredFields = (accountTypeSysname: string, newCurrentItem): boolean => {

        // HID Mobile Access requires Organization Id, User Id, Password
        if (accountTypeSysname === ACCOUNT_TYPE_SYSNAME.ID_HID_MOBILE_ACCESS) {
            return ((newCurrentItem.details.organizationId.value || newCurrentItem.details.userId.value)
            && isAccountLicensed(accountTypeSysname))
        }
         // STid Mobile ID requires User Id, Password, Site Id and Reader Config Id
        else if (accountTypeSysname === ACCOUNT_TYPE_SYSNAME.ID_STID_MOBILE_ID) {
            return (newCurrentItem.details.userId.value
            && (newCurrentItem.isPasswordCaptured || newCurrentItem.tempPassword));
        }
         // Vingcard requires URL, Username and Password
        else if (accountTypeSysname === ACCOUNT_TYPE_SYSNAME.ID_VINGCARD) {
            return newCurrentItem.details.url.value
            && newCurrentItem.details.username.value
            && (newCurrentItem.isPasswordCaptured || newCurrentItem.tempPassword);
        }
        // MQTT requires Client ID, URL, Port and Primo certificate
        else if (accountTypeSysname === ACCOUNT_TYPE_SYSNAME.ID_MQTT_SERVICE) {
            return newCurrentItem.details.tlsClientId.value
            && newCurrentItem.details.tlsUrl.value
            && newCurrentItem.details.tlsPort.value
            && newCurrentItem.details.tlsPrimoCert.value;
        }
        // LDAP
        else if (accountTypeSysname === ACCOUNT_TYPE_SYSNAME.ID_LDAP) {
            return newCurrentItem.details.connectionName.value
            && newCurrentItem.details.host.value
            && newCurrentItem.details.base.value
            && newCurrentItem.details.port.value
            && newCurrentItem.details.username.value
            && (newCurrentItem.isPasswordCaptured || newCurrentItem.tempPassword);
        }
        // Entra
        else if (accountTypeSysname === ACCOUNT_TYPE_SYSNAME.ID_AUTH) {
            return newCurrentItem.details.issuer.value
                && newCurrentItem.details.tenantId.value
                && newCurrentItem.details.redirectUri.value
                && newCurrentItem.details.clientId.value
                && (newCurrentItem.isPasswordCaptured || newCurrentItem.tempPassword)
                && newCurrentItem.details.clientType.value;
        }

        return false;
    }

    const renderDetailsTab = (sysname: string) => {
        const isLicensed: boolean = isAccountLicensed(sysname);
        switch (sysname) {
            case ACCOUNT_TYPE_SYSNAME.ID_HID_MOBILE_ACCESS:
                return <MobileAccountDetails key={itemId} isLicensed={isLicensed} isAccountPopulated={isAccountPopulated} currentItem={currentItem} />
            case ACCOUNT_TYPE_SYSNAME.ID_STID_MOBILE_ID:
                return <StIdMobileAccountDetails key={itemId} isLicensed={isLicensed} isAccountPopulated={isAccountPopulated} currentItem={currentItem} />
            case ACCOUNT_TYPE_SYSNAME.ID_LDAP:
                return <LDAPAccountDetails key={itemId} isAccountPopulated={isAccountPopulated} currentItem={currentItem} />;
            case ACCOUNT_TYPE_SYSNAME.ID_AUTH:
                return <AuthAccountDetails key={itemId} isAccountPopulated={isAccountPopulated} currentItem={currentItem} isAuthTenetRequired={isAuthTenetRequired} isLicensed={isLicensed}/>;
            case ACCOUNT_TYPE_SYSNAME.ID_MQTT_SERVICE:
                return <MqttServiceAccountCertificates key={itemId} />
            case ACCOUNT_TYPE_SYSNAME.ID_VINGCARD:
                return <VingcardAccountDetails key={itemId} isLicensed={isLicensed} isAccountPopulated={isAccountPopulated} currentItem={currentItem} />
        }
    }

    const renderAdvancedTab = (sysname: string) => {
        switch (sysname) {
            case ACCOUNT_TYPE_SYSNAME.ID_AUTH:
                return <AuthAccountAdvanced key={itemId} isAccountPopulated={isAccountPopulated} currentItem={currentItem} />;
        }
    }

    const renderCardView = (sysname: string) => {
        const isLicensed: boolean = isAccountLicensed(sysname);
        switch (sysname) {
            case ACCOUNT_TYPE_SYSNAME.ID_HID_MOBILE_ACCESS:
                return <MobileAccountCard key={itemId} isAccountPopulated={isAccountPopulated} isLicensed={isLicensed} currentItem={currentItem} />;
            case ACCOUNT_TYPE_SYSNAME.ID_STID_MOBILE_ID:
                return <STidMobileAccountCard key={itemId} isAccountPopulated={isAccountPopulated} isLicensed={isLicensed} currentItem={currentItem} />;
            case ACCOUNT_TYPE_SYSNAME.ID_LDAP:
                return <LDAPAccountCard key={itemId} currentItem={currentItem} />;
            case ACCOUNT_TYPE_SYSNAME.ID_AUTH:
                return <AuthAccountCard key={itemId} currentItem={currentItem} updateRequirementForCard={updateAuthTenetRequired} isLicensed={isLicensed}/>;
            case ACCOUNT_TYPE_SYSNAME.ID_MQTT_SERVICE:
                return <MqttServiceAccountCard key={itemId} isAccountPopulated={isAccountPopulated} isLicensed={isLicensed} currentItem={currentItem} setBusy={setBusy}/>;
            case ACCOUNT_TYPE_SYSNAME.ID_VINGCARD:
                return <VingcardAccountCard key={itemId} isAccountPopulated={isAccountPopulated} isLicensed={isLicensed} currentItem={currentItem} />;
        }
    }

    const updateAuthTenetRequired = (removeRequire: boolean) => {
        setIsAuthTenetRequired(removeRequire);
    }

    const topic: Topic = {
        accessor: 'accName',
        title: translate.byKey(TranslationKeys.accounts),
        allItemsPath: allItemsPath,
        itemPath: itemPath,
    }

    const tabContentList: ContentWrapper[] = [
        {
            content: renderDetailsTab(currentItem.accountTypeSysname)
        },
        {
            content: renderAdvancedTab(currentItem.accountTypeSysname)
        }
    ];

    const getTabContent = (index?: number) => {
        const selectedTabContent = tabContentList[index ?? 0];
        return selectedTabContent.content
    };

    const updateTabBadgeTotal = (tabIndex, totalCount, currentTabs) => {
        const newTabs = [...currentTabs];
        newTabs[tabIndex].badge = totalCount;
        return newTabs;
    };

    const saveMobileAccount = (account) => {
        saveAccount(account)
    };

    const saveAccount = async (account) => {
        try {
            setBusy(true);
            await storeMobileAccount(account)

            // Update account information only if the name, enabled state or password has changed
            if (currentItem.name !== account.name || currentItem.enabled !== account.enabled || currentItem.tempPassword !== account.tempPassword) {

                // If the tempPassword is set, encode it before saving
                if (account.tempPassword !== undefined && currentItem.tempPassword !== account.tempPassword) {
                    account.tempPassword = btoa(account.tempPassword); // Encode password before saving
                }

                await editAccount(account)
            }

            // Restart MQTT Broker if TLS settings have changed
            if (currentItem.details.tlsBrokerCert.value !== account.details.tlsBrokerCert.value || currentItem.details.tlsBrokerLocation.value !== account.details.tlsBrokerLocation.value) {
                const command: ExecuteCommand = {
                    cmd: commands.Account.label,
                    cmdSubType: AccountSubCmds.Restart_MQTT_Broker,
                    entityId: "1",
                }

                await executeCommand(command)
            }

            setIsAccountPopulated(true);
            reloadPage();
            toast.success(translate.byKey(TranslationKeys.accountSaved));
        } catch (error) {
            dialog.pushError({ title: translate.byKey(TranslationKeys.error), message: getErrorMessage(error) });
        } finally {
            setBusy(false);
            loadBuildInfo && loadBuildInfo();
        }
    }

    const getHelpTopicKey = (accountTypeSysname: string) => {
        if (accountTypeSysname === ACCOUNT_TYPE_SYSNAME.ID_STID_MOBILE_ID) {
            return SPECIFIC_HELP_KEY.STID_ID_MOBILE;
        }
        else if (accountTypeSysname === ACCOUNT_TYPE_SYSNAME.ID_HID_MOBILE_ACCESS) {
            return SPECIFIC_HELP_KEY.HID_MOBILE_ACCESS;
        }
        else if (accountTypeSysname === ACCOUNT_TYPE_SYSNAME.ID_MQTT_SERVICE) {
            return SPECIFIC_HELP_KEY.MQTT_ACCOUNT;
        }
    }

    return <TopicContextProvider
        topic={topic}
        dataMethod={getMobileAccountNamesWithPagination}
        itemId={itemId}
        selectedItem={selectedItem} >
        <ItemContentTabTwo>
            <SimpleItemDetails
                breadcrumb={breadcrumb}
                busy={busy}
                getTabContent={getTabContent}
                itemProfile={currentItem}
                onBack={() => history.push(allItemsPath)}
                saveDetails={saveMobileAccount}
                tabs={tabs}
                initialValues={currentItem}
                children={
                    renderCardView(currentItem.accountTypeSysname)
                } />
        </ItemContentTabTwo>
    </TopicContextProvider>
}

export default MobileAccount;
